var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ol',_vm._l((_vm.items),function(item,index){return _c('li',{key:index},[_c('router-link',{attrs:{"to":item.path}},[_c('div',{staticClass:"button"},[_vm._v("\n          "+_vm._s(item.title)+"\n         ")])])],1)}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1d968eef","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/myheader.vue
// module id = null
// module chunks = 